export default "__VITE_ASSET__B5EUFNvN__"